import { Resource } from './resource';
import gql from 'graphql-tag';

export class UserResource extends Resource {
  public static async list() {
    return await this.query(
      {
        query: gql`
          query {
            users {
              id
              firstName
              lastName
            }
          }
        `
      },
      'users'
    );
  }

  public static async usersAndCompanies() {
    return this.query({
      query: gql`
        query {
          users {
            id
            firstName
            lastName
            email
            card {
              company {
                id
              }
            }
          }
          companies {
            name
            id
          }
        }
      `
    });
  }

  public static async calendar(month: number, year: number, userId: number) {
    return await this.query({
      query: gql`
        query($month: Int!, $year: Int!, $userId: Int!) {
          workdays(month: $month, year: $year, userId: $userId) {
            id
            start
            end
            date
            overtimeLimit
            overtimeAccepted
            company {
              name
            }
            user {
              id
              firstName
              lastName
            }
          }
          dayoffs(month: $month, year: $year, userId: $userId, status: true) {
            id
            accepted
            reason
            items {
              id
              date
            }
            userId
            user {
              id
              firstName
              lastName
            }
            absenceId
            absence {
              id
              name
            }
            hourStart
            minuteStart
            hourEnd
            minuteEnd
            hrAccept
            managerAccept
          }
          holidays(month: $month, year: $year) {
            date
            name
            color
          }
        }
      `,
      variables: { month, year, userId }
    });
  }

  public static async get(userId: number) {
    return await this.query(
      {
        query: gql`
          query($userId: Int!) {
            user(id: $userId) {
              id
              firstName
              lastName
              email
              createdAt
              roles {
                id
                displayName
              }
              timetables {
                id
                startDate
                endDate
                timetable {
                  name
                  monday
                  tuesday
                  wednesday
                  thursday
                  friday
                  saturday
                  sunday
                }
              }
              card {
                id
                number
                company {
                  id
                  name
                }
              }
            }
          }
        `,
        variables: { userId }
      },
      'user'
    );
  }

  public static async add(schema: any) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($email: String!, $firstName: String!, $lastName: String!, $password: String!, $repeatPassword: String!) {
            createUser(user: { email: $email, firstName: $firstName, lastName: $lastName, password: $password, repeatPassword: $repeatPassword }) {
              id
              firstName
              lastName
              email
            }
          }
        `,
        variables: schema.$model
      },
      'createUser'
    );
  }

  public static async update(id: number, schema: any) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!, $firstName: String, $lastName: String, $email: String, $password: String, $repeatPassword: String) {
            updateUser(id: $id, firstName: $firstName, lastName: $lastName, email: $email, password: $password, repeatPassword: $repeatPassword) {
              firstName
              lastName
              email
              id
            }
          }
        `,
        variables: {
          id,
          ...schema.$model
        }
      },
      'updateUser'
    );
  }

  public static async changePassword(schema: any) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($previousPassword: String!, $password: String!, $retypePassword: String!) {
            changePassword(previousPassword: $previousPassword, password: $password, repeatPassword: $retypePassword)
          }
        `,
        variables: {
          previousPassword: schema.$model.previousPassword,
          password: schema.$model.password,
          retypePassword: schema.$model.repeatPassword
        }
      },
      'changePassword'
    );
  }

  public static async delete(id: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!) {
            removeUser(id: $id)
          }
        `,
        variables: { id }
      },
      'removeUser'
    );
  }
  public static async workdays(month: number, year: number, userId: number) {
    return await this.query({
      query: gql`
        query($month: Int!, $year: Int!, $userId: Int!) {
          workdays(month: $month, year: $year, userId: $userId) {
            id
            start
            end
            date
            overtimeLimit
            overtimeAccepted
            company {
              name
            }
            user {
              id
              firstName
              lastName
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
      variables: { month, year, userId }
    });
  }
}
